import React from 'react';

import ActivityList from '../../components/shared/activitylist/ActivityList';
import MeetingListItem from './MeetingListItem';

import { IGroup, IMeeting } from '../../store/group/groupState';

interface IOwnProps {
    meetings: IMeeting[],
    group: IGroup | undefined;
}

type Props = IOwnProps;

class MeetingList extends React.Component<Props, {}> {
    public render() {
        if (!this.props.group) {
            return null;
        }

        return <ActivityList hasArrow={true}>
            {this.props.meetings.map(meeting => {
                return <MeetingListItem group={this.props.group!} meeting={meeting} key={meeting.meetingId} />;
            })}
        </ActivityList>;
    }
}

export default MeetingList;